import { render, staticRenderFns } from "./DesignTips.vue?vue&type=template&id=181c5757&"
import script from "./DesignTips.vue?vue&type=script&lang=js&"
export * from "./DesignTips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports